module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-00.a872b083.png";